import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { ToasterService } from '@services/toaster.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  constructor(@Inject(OKTA_AUTH) public oktaAuth: OktaAuth,
    private readonly authStateService: OktaAuthStateService,
    private readonly toasterService: ToasterService,
    private readonly router: Router) { }

  async login() {
    try {
      await this.oktaAuth.signInWithRedirect();
    } catch {
      this.toasterService.showError('Login failed, please try again.', 'Login Error');
    }
  }

  ngOnInit(): void {
    void this.initAuthFlow();
  }

  private async initAuthFlow(): Promise<void> {
    // A redirect is already being processed by the callback route — don't start
    // a second, competing auth flow (which orphans the other flow's PKCE verifier).
    if (this.oktaAuth.isLoginRedirect()) return;

    // Already signed in (e.g. landed on /login directly). Route to the last known
    // in-app location instead of forcing another Okta round-trip. Falls through to
    // login() when there's no safe stored route.
    if (await this.oktaAuth.isAuthenticated()) {
      const stored = sessionStorage.getItem('currentRoute');
      // Consume the stored route so a bounce-back can never ping-pong
      // between /login and the guard (the "loading forever" loop).
      sessionStorage.removeItem('currentRoute');
      if (stored && stored !== '/login' && stored !== '/login/callback') {
        this.router.navigate([stored]);
        return;
      }
    }

    this.login();
  }
}
